import React, { FC } from 'react'
import { ArrayElement } from '../../../../shared/types'
import { Button, Dropdown } from '@wmgtech/legato'


type TActionsDropdownProps = {
  actions: {
    key: string
    title: string
    action: () => void
  }[]
}
export const CommentActionsDropdown: FC<TActionsDropdownProps> = (props) => {
  const { actions } = props
  const onSelectAction = (option: ArrayElement<typeof actions>) => {
    if (typeof option.action === 'function') option.action()
  }
  return (
    <Dropdown
      placement={'bottomLeft'}
      list={actions}
      onSelect={onSelectAction}
    >
      <Button
        icon="ellipsis"
        colorType="secondary-black"
        containerStyle="link"
        size="md"
      />
    </Dropdown>
  )
}
